import { toSafeNumber } from '../../helpers/utils'

export const REFUND_LINE_STATUS_UI = {
  pending: { label: 'PENDIENTE', className: 'pending-style' },
  verified: { label: 'VERIFICADO', className: 'received-style' },
  partial: { label: 'PARCIAL', className: 'partial-processed-style' },
  cancelled: { label: 'RECHAZADO', className: 'cancelled-style' }
}

// Compat: backends/payloads antiguos podían enviar rejected.
const REFUND_LINE_STATUS_ALIASES = {
  rejected: 'cancelled'
}

export const getRefundLineOriginalQuantity = (line = {}) =>
  line.original_quantity ?? line.quantity

export const getRefundLineStatusKey = (line = {}) => {
  const rawStatus = line.line_status || line.status
  const status = REFUND_LINE_STATUS_ALIASES[rawStatus] || rawStatus
  if (REFUND_LINE_STATUS_UI[status]) return status
  if (line.verified_quantity == null) return 'pending'

  const verifiedQty = toSafeNumber(line.verified_quantity)
  const originalQty = toSafeNumber(getRefundLineOriginalQuantity(line))
  if (verifiedQty === 0) return 'cancelled'
  if (verifiedQty < originalQty) return 'partial'
  return 'verified'
}

export const getRefundLineStatusUI = (line = {}) =>
  REFUND_LINE_STATUS_UI[getRefundLineStatusKey(line)] || REFUND_LINE_STATUS_UI.pending

export const getRefundLineStatusLabel = (line = {}) => getRefundLineStatusUI(line).label
